var map = {
	"./QRCode1.png": "cc71",
	"./QRCode2.png": "6062",
	"./addcare.png": "fc6e",
	"./banner_index.png": "23b1",
	"./bookcover.png": "c89d",
	"./fengdi.png": "64a1",
	"./finger_QRCode.png": "b2ae",
	"./footer_banner.png": "20c1",
	"./jiantouxia.png": "82fa",
	"./juxing.png": "0af5",
	"./lagel_QRCode.png": "51e8",
	"./laser.png": "05a0",
	"./logo.png": "ede7",
	"./newQRCode.jpg": "d9ae",
	"./report.png": "92f2",
	"./submit_icon.svg": "5721",
	"./tip.png": "a08c",
	"./verify.png": "0ffc",
	"./yanzhengma.png": "bccb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";